// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Plugin Drawer — unified drawer for both mobile and desktop */

/* ===================================================================
   Default: hide drawer elements until drawer-mode is active
   =================================================================== */
.drawer-hamburger {
  display: none;
}

.plugin-drawer {
  display: none;
}

.drawer-overlay {
  display: none;
}

/* ===================================================================
   Shared styles (active when body has .drawer-mode)
   =================================================================== */
body.drawer-mode {

  /* ---- Hamburger Button ---- */
  .drawer-hamburger {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: transparent;
    border: none;
    padding: 5px;
    z-index: 2;
  }

  .drawer-hamburger:active {
    background: rgba(255, 255, 255, 0.15);
  }

  .drawer-hamburger-bar {
    display: block;
    width: 22px;
    height: 3px;
    min-height: 3px;
    background: white;
    margin: 3px 0;
    border-radius: 1px;
    transition: transform var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),
      opacity var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
    transform-origin: center;
  }

  /* Animate bars into X when drawer is open */
  .drawer-hamburger.open .drawer-hamburger-bar:nth-child(1) {
    transform: translateY(8px) rotate(45deg);
  }

  .drawer-hamburger.open .drawer-hamburger-bar:nth-child(2) {
    opacity: 0;
  }

  .drawer-hamburger.open .drawer-hamburger-bar:nth-child(3) {
    transform: translateY(-8px) rotate(-45deg);
  }

  /* ---- Nav Logo ---- */
  .nav-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    height: var(--nav-bar-height);
    padding-left: 1rem;
    margin-right: auto;
    flex-shrink: 0;
  }

  .nav-logo img {
    height: 24px;
    width: auto;
  }

  @media (min-width: 640px) {
    .nav-logo img {
      height: 32px;
      width: auto;
      display: block;
    }
  }

  /* ---- Overlay ---- */
  .drawer-overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    opacity: 0;
    transition: opacity var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
    pointer-events: none;
  }

  .drawer-overlay.open {
    opacity: 1;
    pointer-events: auto;
  }

  /* ---- Drawer Panel ---- */
  .plugin-drawer {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    background: var(--color-dark-background);
    z-index: 1000;
    transform: translateX(-120%);
    transition: transform var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1));
    overflow: visible;
    visibility: hidden;
  }

  .plugin-drawer.ready {
    visibility: visible;
  }

  .plugin-drawer.open {
    transform: translateX(0);
  }

  /* Drawer uses flex column so inner scrolls and utility footer pins to bottom */
  .plugin-drawer {
    display: flex;
    flex-direction: column;
  }

  /* Hide the drawer and hamburger when there are no items */
  .plugin-drawer.drawer-empty,
  .drawer-hamburger.drawer-empty {
    display: none;
  }

  /* Inner wrapper handles scroll — grows to fill available space above the utility footer */
  .drawer-inner {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* ---- Drawer Header ---- */
  .drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 2px solid var(--color-dark-border);
    background: var(--color-dark-background);
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .drawer-title {
    font-size: 18px;
    font-weight: bold;
    color: white;
    width: 100%;
    text-align: center;
  }

  /* ---- Drawer Search Trigger ---- */
  .drawer-search {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    background: var(--color-dark-background);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: var(--kt-radius-sm, 4px);
    margin: 10px 12px;
    cursor: pointer;
    transition: border-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),
      background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .drawer-search:hover {
    border-color: rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.06);
  }

  .drawer-search-icon {
    width: 16px;
    height: 16px;
    opacity: 0.5;
    flex-shrink: 0;
    filter: var(--filter-icon-blue);
  }

  .drawer-search-label {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.35);
    flex: 1;
  }

  .drawer-search-shortcut {
    padding: 2px 6px;
    border-radius: var(--kt-radius-sm, 4px);
    font-size: var(--kt-font-xs, 11px);
    font-family: 'Roboto Mono', monospace;
    color: var(--kt-text-tertiary, rgba(255, 255, 255, 0.45));
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.1);
    white-space: nowrap;
    flex-shrink: 0;
  }

  /* ---- Top Actions Row (search + app launcher) ---- */
  .drawer-top-actions {
    display: flex;
    align-items: center;
  }

  .drawer-top-actions .drawer-search {
    flex: 1;
    min-width: 0;
    margin-right: 0;
  }

  /* ---- App Launcher Button ---- */
  .drawer-app-launcher {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    margin: 10px 12px 10px 8px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: var(--kt-radius-sm, 4px);
    cursor: pointer;
    transition: border-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),
      background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .drawer-app-launcher:hover {
    border-color: rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.06);
  }

  .drawer-app-launcher-icon {
    width: 20px;
    height: 20px;
    opacity: 0.7;
    filter: var(--filter-icon-blue);
    transition: opacity var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .drawer-app-launcher:hover .drawer-app-launcher-icon {
    opacity: 1;
  }

  /* ---- Drawer Content ---- */
  .drawer-content {
    padding-bottom: 20px;
  }

  /* ---- Collapsible Groups ---- */
  .drawer-group-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    cursor: pointer;
    user-select: none;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: white;
    background: var(--color-dark-border);
    border-bottom: 1px solid var(--color-dark-border);
    transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .drawer-group-header:hover {
    background: rgba(255, 255, 255, 0.05);
  }

  .drawer-group-label {}

  .drawer-group-chevron {
    transition: transform var(--kt-duration-normal, 200ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
    font-size: 12px;
    color: rgba(255, 255, 255, 0.4);
  }

  .drawer-group.collapsed .drawer-group-chevron {
    transform: rotate(-90deg);
  }

  .drawer-group-items {
    overflow: hidden;
    transition: max-height var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
    max-height: 2000px;
  }

  .drawer-group.collapsed .drawer-group-items {
    max-height: 0;
  }

  /* ---- Drawer Items ---- */
  .drawer-item {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    cursor: pointer;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    transition:
      background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),
      transform var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .drawer-item:not(.disabled):hover {
    background: rgba(255, 255, 255, 0.08);
  }

  .drawer-item:not(.disabled):active {
    background: rgba(255, 255, 255, 0.12);
  }

  .drawer-item:not(.disabled):active .drawer-item-icon {
    filter: hue-rotate(275deg) brightness(1.2);
  }

  .drawer-item:active .drawer-item-label {
    color: var(--color-dark-text-accent);
  }

  .drawer-item-icon {
    width: 28px;
    height: 28px;
    margin-right: 12px;
    flex-shrink: 0;
    filter: var(--filter-icon-blue);
  }

  .drawer-item-label {
    font-size: 14px;
    color: white;
    flex: 1;
    min-width: 0;
  }

  .drawer-item-shortcut {
    margin-left: auto;
    padding: 2px 6px;
    border-radius: var(--kt-radius-sm, 4px);
    font-size: var(--kt-font-xs, 11px);
    font-family: 'Roboto Mono', monospace;
    color: var(--kt-text-tertiary, rgba(255, 255, 255, 0.45));
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.1);
    white-space: nowrap;
    flex-shrink: 0;
  }

  .drawer-item.active .drawer-item-icon {
    filter: hue-rotate(275deg) brightness(1.2);
  }

  .drawer-item.active .drawer-item-label {
    color: var(--color-dark-text-accent);
  }

  /*
   * Stay clickable (and hoverable) even when disabled: a click forwards to the
   * plugin so it can toast *why* it is unavailable, and the not-allowed cursor
   * signals it is not a normal action. (pointer-events: none would swallow the
   * click and the hint with it.)
   */
  .drawer-item.disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }

  .drawer-item.disabled .drawer-item-icon {
    filter: grayscale(1);
  }

  /* ---- Status Badges ---- */
  .drawer-item-badge:empty {
    display: none;
  }

  .drawer-item-badge--active {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #4caf50;
    margin-left: 8px;
    flex-shrink: 0;
  }

  .drawer-item-badge--count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    border-radius: 9px;
    background: var(--color-primary, #1e88e5);
    color: white;
    font-size: 10px;
    font-weight: 600;
    padding: 0 5px;
    margin-left: 8px;
    flex-shrink: 0;
  }

  /* Pro-locked items — match bottom menu yellow tint, only while logged out.
     \`&\` is the enclosing body.drawer-mode, so this gates on the body-level
     .user-logged-in class without a (never-matching) nested body descendant.
     .login-gate-bypassed is the Konami-code bypass, which clears the tint too. */
  &:not(.user-logged-in):not(.login-gate-bypassed) .drawer-item.bmenu-item-pro .drawer-item-icon {
    filter: hue-rotate(227deg) brightness(1.2);
  }

  &:not(.user-logged-in):not(.login-gate-bypassed) .drawer-item.bmenu-item-pro:hover .drawer-item-icon {
    filter: hue-rotate(227deg) brightness(1.8);
  }

  /* ---- User Account (pinned above utility footer) ---- */
  .drawer-user-account:empty {
    display: none;
  }

  .drawer-user-account {
    flex-shrink: 0;
    border-top: 2px solid var(--color-dark-border);
    background: var(--color-dark-background);
    padding: 16px;
  }

  .drawer-user-account__row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 4px;
    border-radius: 6px;
    cursor: pointer;
    text-decoration: none;
    color: white;
    transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .drawer-user-account__row:hover {
    background: rgba(255, 255, 255, 0.08);
  }

  .drawer-user-account__avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
  }

  .drawer-user-account__avatar--default {
    filter: grayscale(1);
  }

  .drawer-user-account__initials {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #aeaeae;
    font-weight: 600;
    font-size: 0.8rem;
    color: var(--color-dark-background);
  }

  .drawer-user-account__name {
    font-size: 13px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* ---- Status Footer Container ---- */
  .drawer-status-footer-container:empty {
    display: none;
  }

  .drawer-status-footer-container {
    flex-shrink: 0;
    padding: 12px 16px;
    border-top: 1px solid var(--color-dark-border);
    background: var(--color-dark-background);
  }

  /* ---- Status Footer ---- */
  .drawer-status-footer {
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.45);
  }

  .drawer-status-connectivity {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
  }

  .drawer-status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #4caf50;
    flex-shrink: 0;
  }

  .drawer-status-dot--offline {
    background: #f44336;
  }

  .drawer-status-connectivity-label {
    color: #4caf50;
  }

  .drawer-status-connectivity-label--offline {
    color: #f44336;
  }

  .drawer-status-version {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.35);
  }

  .drawer-phone-link {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    margin-left: auto;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: var(--kt-radius-sm, 4px);
    cursor: pointer;
    transition: border-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),
      background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .drawer-phone-link:hover {
    border-color: rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.06);
  }

  .drawer-phone-link-icon {
    width: 20px;
    height: 20px;
    color: var(--kt-accent-light, #e01a0e);
    opacity: 0.9;
    transition: opacity var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .drawer-phone-link:hover .drawer-phone-link-icon {
    opacity: 1;
  }

  /* Signed out: yellow + disabled (sign in to enable). */
  .drawer-phone-link--disabled {
    cursor: default;
  }

  .drawer-phone-link--disabled:hover {
    border-color: rgba(255, 255, 255, 0.15);
    background: transparent;
  }

  .drawer-phone-link--disabled .drawer-phone-link-icon {
    color: #f6c343;
    opacity: 0.6;
  }

  .drawer-phone-link--disabled:hover .drawer-phone-link-icon {
    opacity: 0.6;
  }

  /* ---- Utility Footer (fixed to bottom-right of viewport) ---- */
  .drawer-utility-footer:empty {
    display: none;
  }

  .drawer-utility-footer {
    position: fixed;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10000;
    background: rgba(30, 30, 30, 0.75);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow: hidden;
    /* Collapsed: small centered pill */
    max-width: 48px;
    padding: 6px;
    gap: 0;
    cursor: pointer;
    transition: max-width var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1)),
      padding var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1)),
      gap var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1)),
      border-radius var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1));
  }

  /* .expanded pins the hover state open (mobile tap-to-expand reuses it, and
     the onboarding tour pins it while a step spotlights a footer icon) */
  .drawer-utility-footer:hover,
  .drawer-utility-footer.expanded {
    max-width: 90vw;
    padding: 6px 12px;
    gap: 2px;
    cursor: default;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  }

  /* Collapsed indicator — grid icon */
  .drawer-utility-footer::before {
    content: '\\2630';
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    font-size: 18px;
    color: rgba(255, 255, 255, 0.5);
    flex-shrink: 0;
    transition: opacity var(--kt-duration-fast, 100ms),
      width var(--kt-duration-slow, 300ms),
      margin var(--kt-duration-slow, 300ms);
  }

  .drawer-utility-footer:hover::before,
  .drawer-utility-footer.expanded::before {
    width: 0;
    opacity: 0;
    overflow: hidden;
    margin: 0;
  }

  /* Sections flow horizontally with dividers */
  .drawer-utility-section {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    /* Hidden when collapsed */
    max-width: 0;
    opacity: 0;
    overflow: hidden;
    transition: max-width var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1)),
      opacity var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1));
  }

  .drawer-utility-footer:hover .drawer-utility-section,
  .drawer-utility-footer.expanded .drawer-utility-section {
    max-width: 600px;
    opacity: 1;
  }

  /* Vertical divider between sections */
  .drawer-utility-section+.drawer-utility-section::before {
    content: '';
    display: block;
    width: 1px;
    height: 20px;
    background: rgba(255, 255, 255, 0.15);
    flex-shrink: 0;
    margin-right: 4px;
  }

  .drawer-utility-section-label {
    display: none;
    /* Labels hidden in dock mode — icons are self-explanatory with tooltips */
  }

  .drawer-utility-icons {
    display: flex;
    flex-wrap: nowrap;
    gap: 2px;
  }

  .drawer-utility-icon {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 8px;
    transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),
      transform var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .drawer-utility-icon img {
    width: 20px;
    height: 20px;
    filter: var(--filter-icon-blue);
    opacity: 0.7;
    transition: opacity var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .drawer-utility-icon:hover {
    background: rgba(255, 255, 255, 0.12);
    transform: scale(1.15);
  }

  .drawer-utility-icon:hover img {
    opacity: 1;
  }

  .drawer-utility-icon:active img {
    filter: hue-rotate(275deg) brightness(1.2);
    opacity: 1;
  }

  .drawer-utility-icon.bmenu-item-selected img {
    filter: hue-rotate(275deg) brightness(1.2);
    opacity: 1;
  }

  .drawer-utility-icon.bmenu-item-disabled {
    pointer-events: none;
  }

  .drawer-utility-icon.bmenu-item-disabled img {
    opacity: 0.2;
    filter: grayscale(1);
  }

  /* ---- Rail Toggle Button ---- */
  .drawer-rail-toggle {
    display: none;
  }

}

/* ===================================================================
   Desktop-specific styles
   =================================================================== */
body.drawer-mode:not(.is-mobile-mode) {

  .plugin-drawer.desktop-mode {
    width: 420px;
    top: var(--top-menu-height);
    height: calc(100% - var(--top-menu-height));
  }

  /* Desktop: hide hamburger — rail is always visible */
  .drawer-hamburger {
    display: none !important;
  }

  .drawer-item {
    padding: 8px 16px;
  }

  .drawer-item-icon {
    width: 24px;
    height: 24px;
  }

  .drawer-item-label {
    font-size: 13px;
  }

  /* Hide nav items that moved to the drawer utility footer or are redundant */
  #sound-btn,
  #layers-menu-btn,
  #GithubLinkPlugin-root,
  #search-btn,
  .user-account__menu-item {
    display: none !important;
  }

  /* Always-open search bar on desktop */
  #search-holder {
    display: flex !important;
    width: 420px !important;
    transition: none !important;
  }

  #search-holder.search-slide-up {
    width: 420px !important;
    border-left: 5px solid var(--color-dark-border);

  }

  #search-holder.search-slide-up input[type='search'] {
    width: 100% !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  /* ---- Rail Toggle Button (desktop only) ---- */
  .drawer-rail-toggle {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    padding: 10px 16px;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.4);
    border-top: 1px solid var(--color-dark-border);
    font-size: 12px;
    transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .drawer-rail-toggle:hover {
    background: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.7);
  }

  .drawer-rail-toggle-icon {
    width: 28px;
    height: 28px;
    flex-shrink: 0;
    filter: var(--filter-icon-blue);
  }

  .drawer-rail-toggle-label {
    flex: 1;
    color: rgba(255, 255, 255, 0.45);
  }

  .drawer-rail-toggle-shortcut {
    padding: 2px 6px;
    border-radius: var(--kt-radius-sm, 4px);
    font-size: var(--kt-font-xs, 11px);
    font-family: 'Roboto Mono', monospace;
    color: var(--kt-text-tertiary, rgba(255, 255, 255, 0.45));
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.1);
    white-space: nowrap;
    flex-shrink: 0;
  }

  /* ---- Rail Mode (desktop only) ---- */
  .plugin-drawer.rail-mode {
    transform: translateX(0);
    width: 60px;
    overflow: hidden;
    transition: width var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1)),
      box-shadow var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1));
  }

  /* The whole top-actions row collapses in rail mode so plugin-injected
     buttons (e.g. the favorites filter/export) collapse with it instead of
     lingering as orphaned boxes above the drawer items */
  .plugin-drawer.rail-mode .drawer-top-actions {
    max-height: 0;
    overflow: hidden;
    transition: max-height var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-top-actions {
    max-height: 60px;
  }

  .plugin-drawer.rail-mode .drawer-search {
    overflow: hidden;
    max-height: 0;
    padding: 0;
    margin: 0;
    border: none;
    opacity: 0;
    transition: max-height var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),
      padding var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),
      margin var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),
      opacity var(--kt-duration-normal, 200ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  /* App launcher collapses with the search in rail mode */
  .plugin-drawer.rail-mode .drawer-app-launcher {
    max-width: 0;
    margin: 0;
    border: none;
    opacity: 0;
    overflow: hidden;
    transition: max-width var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),
      margin var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),
      opacity var(--kt-duration-normal, 200ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-app-launcher {
    max-width: 40px;
    margin: 10px 12px 10px 8px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    opacity: 1;
  }

  .plugin-drawer.rail-mode .drawer-group-header {
    padding: 10px 12px;
    justify-content: center;
    background: transparent;
    pointer-events: none;
  }

  .plugin-drawer.rail-mode .drawer-group-label {
    display: none;
  }

  .plugin-drawer.rail-mode .drawer-group-chevron {
    display: none;
  }

  .plugin-drawer.rail-mode .drawer-group-header::after {
    content: '';
    display: block;
    width: 24px;
    height: 1px;
    background: rgba(255, 255, 255, 0.12);
    transition: opacity var(--kt-duration-normal, 200ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .plugin-drawer.rail-mode .drawer-item {
    position: relative;
    padding: 8px 12px;
    justify-content: center;
    transition: padding var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .plugin-drawer.rail-mode .drawer-item-label {
    display: none;
  }

  .plugin-drawer.rail-mode .drawer-item-icon {
    margin-right: 0;
    transition: margin var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .plugin-drawer.rail-mode .drawer-item-shortcut {
    display: none;
  }

  .plugin-drawer.rail-mode .drawer-item-badge--count {
    position: absolute;
    top: 2px;
    right: 2px;
    margin-left: 0;
    font-size: 8px;
    min-width: 14px;
    height: 14px;
    border-radius: 7px;
    padding: 0 3px;
  }

  .plugin-drawer.rail-mode .drawer-item-badge--active {
    position: absolute;
    top: 4px;
    right: 4px;
    margin-left: 0;
    width: 6px;
    height: 6px;
  }

  .plugin-drawer.rail-mode .drawer-user-account,
  .plugin-drawer.rail-mode .drawer-status-footer-container {
    opacity: 0;
    max-height: 0;
    padding: 0;
    border: none;
    overflow: hidden;
    transition: max-height var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),
      opacity var(--kt-duration-normal, 200ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),
      padding var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .plugin-drawer.rail-mode .drawer-rail-toggle {
    justify-content: center;
    padding: 10px 0;
  }

  .plugin-drawer.rail-mode .drawer-rail-toggle-icon {
    width: 28px;
    height: 28px;
  }

  .plugin-drawer.rail-mode .drawer-rail-toggle-label {
    display: none;
  }

  .plugin-drawer.rail-mode .drawer-rail-toggle-shortcut {
    display: none;
  }

  /* Collapsed groups should still show icons in rail mode */
  .plugin-drawer.rail-mode .drawer-group.collapsed .drawer-group-items {
    max-height: 2000px;
  }

  /* Restore normal collapse behavior when rail is hovered (expanded) */
  .plugin-drawer.rail-mode.rail-hover .drawer-group.collapsed .drawer-group-items {
    max-height: 0;
  }

  /* Rail mode hover expansion — triggered by JS class on .drawer-inner hover */
  .plugin-drawer.rail-mode.rail-hover {
    width: 420px;
    box-shadow: 4px 0 16px rgba(0, 0, 0, 0.3);
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-inner {
    min-width: 420px;
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-search {
    max-height: 60px;
    padding: 10px 12px;
    margin: 10px 12px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    opacity: 1;
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-group-header {
    padding-left: 16px;
    padding-right: 16px;
    justify-content: space-between;
    background: var(--color-dark-border);
    pointer-events: auto;
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-group-label {
    display: inline;
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-group-chevron {
    display: inline;
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-group-header::after {
    opacity: 0;
    height: 0;
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-item {
    padding-left: 16px;
    padding-right: 16px;
    justify-content: flex-start;
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-item-label {
    display: inline;
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-item-icon {
    margin-right: 12px;
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-item-shortcut {
    display: inline;
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-item-badge--count,
  .plugin-drawer.rail-mode.rail-hover .drawer-item-badge--active {
    position: static;
    margin-left: 8px;
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-item-badge--count {
    font-size: 10px;
    min-width: 18px;
    height: 18px;
    border-radius: 9px;
    padding: 0 5px;
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-item-badge--active {
    width: 8px;
    height: 8px;
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-user-account {
    opacity: 1;
    max-height: 100px;
    padding: 16px;
    border-top: 2px solid var(--color-dark-border);
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-status-footer-container {
    opacity: 1;
    max-height: 80px;
    padding: 12px 16px;
    border-top: 1px solid var(--color-dark-border);
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-rail-toggle {
    padding: 10px 16px;
    justify-content: flex-start;
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-rail-toggle-label {
    display: inline;
  }

  .plugin-drawer.rail-mode.rail-hover .drawer-rail-toggle-shortcut {
    display: inline;
  }

  /* Side menus respect the rail offset */
  .side-menu-parent {
    left: var(--drawer-offset, 0px);
  }

}

/* ===================================================================
   Mobile-specific styles (device-based, not viewport-based)
   =================================================================== */
body.is-mobile-mode {

  /* Mobile hamburger is in the nav bar (top-left) */
  .drawer-hamburger {
    position: relative;
    width: var(--nav-bar-height);
    height: var(--nav-bar-height);
    background: transparent;
    flex-shrink: 0;
  }

  /* Compact orange logo for mobile */
  .nav-logo {
    padding-left: 0.25rem;
  }

  .nav-logo img {
    height: 28px;
  }

  .plugin-drawer.mobile-mode {
    width: 80%;
    top: 0;
    height: 100%;
  }

  .drawer-overlay {
    background: rgba(0, 0, 0, 0.7);
  }

  .drawer-item {
    padding: 12px 16px;
  }

  .drawer-item-icon {
    width: 28px;
    height: 28px;
  }

  .drawer-item-label {
    font-size: 14px;
  }

  /* ---- Hide desktop bottom menu on mobile ---- */
  footer#nav-footer {
    display: none !important;
  }

  /* ---- Hide top menu icon <li> items (they're in the drawer now) ---- */
  #nav-top-right>li {
    display: none !important;
  }

  /* ---- Always-open search on mobile ---- */
  #search-holder {
    display: flex !important;
    width: 140px !important;
    margin-left: auto;
    transition: none !important;
  }

  #search-holder.search-slide-up {
    width: 140px !important;
  }

  #search-holder.search-slide-up input[type='search'] {
    width: 100% !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .drawer-search {
    display: none !important;
  }

  /* Hide keyboard shortcut hints on mobile */
  .drawer-item-shortcut,
  .drawer-rail-toggle-shortcut {
    display: none !important;
  }

  /* Hide the search toggle button (search is always visible) */
  #search-btn {
    display: none !important;
  }

  /* ---- Nav wrapper mobile layout ---- */
  #nav-wrapper {
    justify-content: space-between !important;
    align-items: center !important;
  }

  #nav-top-center {
    flex: 1;
    min-width: 0;
  }

  #nav-top-right {
    flex-shrink: 0;
  }

  /* ---- Force side menus to full-screen on mobile ---- */
  .side-menu-parent {
    position: fixed !important;
    top: var(--top-menu-height) !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100vw !important;
    max-width: 100vw !important;
    min-width: 0 !important;
  }

  /* Prevent wide content from expanding the side menu beyond viewport */
  .side-menu {
    overflow-x: hidden !important;
    max-width: 100vw !important;
  }

  /* Make title text flexible so close button stays on-screen */
  .side-menu-title-text {
    width: auto !important;
    flex: 1 1 0 !important;
    min-width: 50% !important;
    max-width: none !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: clamp(0.75rem, 3.5vw, 1rem);
  }

  /* Ensure close button section doesn't shrink below its content */
  .side-menu-title-right {
    flex-shrink: 0 !important;
  }

  /* Add right padding to close button so it's not cramped against the edge */
  .side-menu-title-bar {
    padding-right: 0.5rem;
    max-width: 100%;
    overflow: hidden;
  }

  /* Allow horizontal scrolling inside the content area for wide tables */
  .side-menu .row {
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    max-width: calc(100vw - 2rem);
  }

  /* Force tables inside side menus to be scrollable */
  .side-menu table {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    max-width: calc(100vw - 2rem);
  }

  .side-menu thead,
  .side-menu tbody {
    display: block;
    width: max-content;
    min-width: 100%;
  }

  /* ---- Utility footer: replace :hover with .expanded class on mobile ---- */
  .drawer-utility-footer {
    /* Disable hover-based expansion on touch devices */
    max-width: 48px;
    padding: 6px;
    gap: 0;
  }

  .drawer-utility-footer:hover {
    max-width: 48px;
    padding: 6px;
    gap: 0;
    cursor: pointer;
    box-shadow: none;
  }

  .drawer-utility-footer:hover::before {
    width: 28px;
    opacity: 1;
    overflow: visible;
  }

  .drawer-utility-footer:hover .drawer-utility-section {
    max-width: 0;
    opacity: 0;
  }

  /* JS-toggled expanded state */
  .drawer-utility-footer.expanded {
    max-width: 90vw;
    padding: 6px 12px;
    gap: 2px;
    cursor: default;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  }

  .drawer-utility-footer.expanded::before {
    width: 0;
    opacity: 0;
    overflow: hidden;
    margin: 0;
  }

  .drawer-utility-footer.expanded .drawer-utility-section {
    max-width: 600px;
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/ui/plugin-drawer.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;;wEAEwE;AACxE;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;wEAEwE;AACxE;;EAEE,+BAA+B;EAC/B;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,cAAc;IACd,WAAW;IACX,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB;mGAC+F;IAC/F,wBAAwB;EAC1B;;EAEA,4CAA4C;EAC5C;IACE,wCAAwC;EAC1C;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,0CAA0C;EAC5C;;EAEA,uBAAuB;EACvB;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE;MACE,YAAY;MACZ,WAAW;MACX,cAAc;IAChB;EACF;;EAEA,sBAAsB;EACtB;IACE,cAAc;IACd,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,YAAY;IACZ,UAAU;IACV,yGAAyG;IACzG,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA,2BAA2B;EAC3B;IACE,cAAc;IACd,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,wCAAwC;IACxC,aAAa;IACb,4BAA4B;IAC5B,uGAAuG;IACvG,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,+EAA+E;EAC/E;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA,0DAA0D;EAC1D;;IAEE,aAAa;EACf;;EAEA,0FAA0F;EAC1F;IACE,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA,4BAA4B;EAC5B;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,iDAAiD;IACjD,wCAAwC;IACxC,gBAAgB;IAChB,MAAM;IACN,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,kBAAkB;EACpB;;EAEA,oCAAoC;EACpC;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,wCAAwC;IACxC,2CAA2C;IAC3C,uCAAuC;IACvC,iBAAiB;IACjB,eAAe;IACf;4GACwG;EAC1G;;EAEA;IACE,sCAAsC;IACtC,qCAAqC;EACvC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,+BAA+B;EACjC;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,OAAO;EACT;;EAEA;IACE,gBAAgB;IAChB,uCAAuC;IACvC,kCAAkC;IAClC,qCAAqC;IACrC,yDAAyD;IACzD,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;IACnB,cAAc;EAChB;;EAEA,sDAAsD;EACtD;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,OAAO;IACP,YAAY;IACZ,eAAe;EACjB;;EAEA,kCAAkC;EAClC;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,2CAA2C;IAC3C,uCAAuC;IACvC,eAAe;IACf;4GACwG;EAC1G;;EAEA;IACE,sCAAsC;IACtC,qCAAqC;EACvC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,+BAA+B;IAC/B,yGAAyG;EAC3G;;EAEA;IACE,UAAU;EACZ;;EAEA,6BAA6B;EAC7B;IACE,oBAAoB;EACtB;;EAEA,iCAAiC;EACjC;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,oCAAoC;IACpC,iDAAiD;IACjD,kHAAkH;EACpH;;EAEA;IACE,qCAAqC;EACvC;;EAEA,qBAAqB;;EAErB;IACE,6GAA6G;IAC7G,eAAe;IACf,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,4GAA4G;IAC5G,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA,2BAA2B;EAC3B;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kDAAkD;IAClD;;qGAEiG;EACnG;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,+BAA+B;EACjC;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,OAAO;IACP,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,uCAAuC;IACvC,kCAAkC;IAClC,qCAAqC;IACrC,yDAAyD;IACzD,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,oCAAoC;EACtC;;EAEA;;;;;IAKE;EACF;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA,4BAA4B;EAC5B;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,yCAAyC;IACzC,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,cAAc;EAChB;;EAEA;;;iFAG+E;EAC/E;IACE,0CAA0C;EAC5C;;EAEA;IACE,0CAA0C;EAC5C;;EAEA,yDAAyD;EACzD;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,8CAA8C;IAC9C,wCAAwC;IACxC,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,kHAAkH;EACpH;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,mCAAmC;EACrC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA,sCAAsC;EACtC;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,8CAA8C;IAC9C,wCAAwC;EAC1C;;EAEA,4BAA4B;EAC5B;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,2CAA2C;IAC3C,uCAAuC;IACvC,eAAe;IACf;4GACwG;EAC1G;;EAEA;IACE,sCAAsC;IACtC,qCAAqC;EACvC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,YAAY;IACZ,yGAAyG;EAC3G;;EAEA;IACE,UAAU;EACZ;;EAEA,uDAAuD;EACvD;IACE,eAAe;EACjB;;EAEA;IACE,uCAAuC;IACvC,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA,iEAAiE;EACjE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,cAAc;IACd,kCAAkC;IAClC,2BAA2B;IAC3B,mCAAmC;IACnC,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,mCAAmC;IACnC,eAAe;IACf,YAAY;IACZ,MAAM;IACN,eAAe;IACf;;;qGAGiG;EACnG;;EAEA;yEACuE;EACvE;;IAEE,eAAe;IACf,iBAAiB;IACjB,QAAQ;IACR,eAAe;IACf,yCAAyC;EAC3C;;EAEA,oCAAoC;EACpC;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,+BAA+B;IAC/B,cAAc;IACd;;2CAEuC;EACzC;;EAEA;;IAEE,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,SAAS;EACX;;EAEA,6CAA6C;EAC7C;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;IACR,0BAA0B;IAC1B,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB;+FAC2F;EAC7F;;EAEA;;IAEE,gBAAgB;IAChB,UAAU;EACZ;;EAEA,sCAAsC;EACtC;IACE,WAAW;IACX,cAAc;IACd,UAAU;IACV,YAAY;IACZ,qCAAqC;IACrC,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,0EAA0E;EAC5E;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB;qGACiG;EACnG;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,YAAY;IACZ,yGAAyG;EAC3G;;EAEA;IACE,qCAAqC;IACrC,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,0CAA0C;IAC1C,UAAU;EACZ;;EAEA;IACE,0CAA0C;IAC1C,UAAU;EACZ;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,oBAAoB;EACtB;;EAEA,iCAAiC;EACjC;IACE,aAAa;EACf;;AAEF;;AAEA;;wEAEwE;AACxE;;EAEE;IACE,YAAY;IACZ,2BAA2B;IAC3B,2CAA2C;EAC7C;;EAEA,qDAAqD;EACrD;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA,4EAA4E;EAC5E;;;;;IAKE,wBAAwB;EAC1B;;EAEA,sCAAsC;EACtC;IACE,wBAAwB;IACxB,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,+CAA+C;;EAEjD;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA,gDAAgD;EAChD;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,+BAA+B;IAC/B,8CAA8C;IAC9C,eAAe;IACf,kHAAkH;EACpH;;EAEA;IACE,qCAAqC;IACrC,+BAA+B;EACjC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,+BAA+B;EACjC;;EAEA;IACE,OAAO;IACP,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,uCAAuC;IACvC,kCAAkC;IAClC,qCAAqC;IACrC,yDAAyD;IACzD,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;IACnB,cAAc;EAChB;;EAEA,uCAAuC;EACvC;IACE,wBAAwB;IACxB,WAAW;IACX,gBAAgB;IAChB;kGAC8F;EAChG;;EAEA;;yDAEuD;EACvD;IACE,aAAa;IACb,gBAAgB;IAChB,4GAA4G;EAC9G;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,SAAS;IACT,YAAY;IACZ,UAAU;IACV;;;qGAGiG;EACnG;;EAEA,wDAAwD;EACxD;IACE,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB;;qGAEiG;EACnG;;EAEA;IACE,eAAe;IACf,0BAA0B;IAC1B,2CAA2C;IAC3C,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,qCAAqC;IACrC,2GAA2G;EAC7G;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,yGAAyG;EAC3G;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,wGAAwG;EAC1G;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,cAAc;IACd,cAAc;IACd,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,cAAc;IACd,UAAU;IACV,WAAW;EACb;;EAEA;;IAEE,UAAU;IACV,aAAa;IACb,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB;;mGAE+F;EACjG;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA,0DAA0D;EAC1D;IACE,kBAAkB;EACpB;;EAEA,qEAAqE;EACrE;IACE,aAAa;EACf;;EAEA,6EAA6E;EAC7E;IACE,YAAY;IACZ,yCAAyC;EAC3C;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,2CAA2C;IAC3C,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,oCAAoC;IACpC,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,8CAA8C;EAChD;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,8CAA8C;EAChD;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,uCAAuC;EACvC;IACE,+BAA+B;EACjC;;AAEF;;AAEA;;wEAEwE;AACxE;;EAEE,kDAAkD;EAClD;IACE,kBAAkB;IAClB,4BAA4B;IAC5B,6BAA6B;IAC7B,uBAAuB;IACvB,cAAc;EAChB;;EAEA,mCAAmC;EACnC;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,MAAM;IACN,YAAY;EACd;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA,iDAAiD;EACjD;IACE,wBAAwB;EAC1B;;EAEA,wEAAwE;EACxE;IACE,wBAAwB;EAC1B;;EAEA,2CAA2C;EAC3C;IACE,wBAAwB;IACxB,uBAAuB;IACvB,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,2CAA2C;EAC3C;;IAEE,wBAAwB;EAC1B;;EAEA,6DAA6D;EAC7D;IACE,wBAAwB;EAC1B;;EAEA,wCAAwC;EACxC;IACE,yCAAyC;IACzC,8BAA8B;EAChC;;EAEA;IACE,OAAO;IACP,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA,wDAAwD;EACxD;IACE,0BAA0B;IAC1B,sCAAsC;IACtC,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA,sEAAsE;EACtE;IACE,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA,6DAA6D;EAC7D;IACE,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA,iEAAiE;EACjE;IACE,yBAAyB;EAC3B;;EAEA,2EAA2E;EAC3E;IACE,qBAAqB;IACrB,eAAe;IACf,gBAAgB;EAClB;;EAEA,uEAAuE;EACvE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,6BAA6B;EAC/B;;EAEA,oDAAoD;EACpD;IACE,cAAc;IACd,gBAAgB;IAChB,iCAAiC;IACjC,6BAA6B;EAC/B;;EAEA;;IAEE,cAAc;IACd,kBAAkB;IAClB,eAAe;EACjB;;EAEA,4EAA4E;EAC5E;IACE,mDAAmD;IACnD,eAAe;IACf,YAAY;IACZ,MAAM;EACR;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA,8BAA8B;EAC9B;IACE,eAAe;IACf,iBAAiB;IACjB,QAAQ;IACR,eAAe;IACf,yCAAyC;EAC3C;;EAEA;IACE,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;AACF","sourcesContent":["/* Plugin Drawer — unified drawer for both mobile and desktop */\n\n/* ===================================================================\n   Default: hide drawer elements until drawer-mode is active\n   =================================================================== */\n.drawer-hamburger {\n  display: none;\n}\n\n.plugin-drawer {\n  display: none;\n}\n\n.drawer-overlay {\n  display: none;\n}\n\n/* ===================================================================\n   Shared styles (active when body has .drawer-mode)\n   =================================================================== */\nbody.drawer-mode {\n\n  /* ---- Hamburger Button ---- */\n  .drawer-hamburger {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    background: transparent;\n    border: none;\n    padding: 5px;\n    z-index: 2;\n  }\n\n  .drawer-hamburger:active {\n    background: rgba(255, 255, 255, 0.15);\n  }\n\n  .drawer-hamburger-bar {\n    display: block;\n    width: 22px;\n    height: 3px;\n    min-height: 3px;\n    background: white;\n    margin: 3px 0;\n    border-radius: 1px;\n    transition: transform var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),\n      opacity var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n    transform-origin: center;\n  }\n\n  /* Animate bars into X when drawer is open */\n  .drawer-hamburger.open .drawer-hamburger-bar:nth-child(1) {\n    transform: translateY(8px) rotate(45deg);\n  }\n\n  .drawer-hamburger.open .drawer-hamburger-bar:nth-child(2) {\n    opacity: 0;\n  }\n\n  .drawer-hamburger.open .drawer-hamburger-bar:nth-child(3) {\n    transform: translateY(-8px) rotate(-45deg);\n  }\n\n  /* ---- Nav Logo ---- */\n  .nav-logo {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: var(--nav-bar-height);\n    padding-left: 1rem;\n    margin-right: auto;\n    flex-shrink: 0;\n  }\n\n  .nav-logo img {\n    height: 24px;\n    width: auto;\n  }\n\n  @media (min-width: 640px) {\n    .nav-logo img {\n      height: 32px;\n      width: auto;\n      display: block;\n    }\n  }\n\n  /* ---- Overlay ---- */\n  .drawer-overlay {\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 999;\n    opacity: 0;\n    transition: opacity var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n    pointer-events: none;\n  }\n\n  .drawer-overlay.open {\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  /* ---- Drawer Panel ---- */\n  .plugin-drawer {\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100%;\n    background: var(--color-dark-background);\n    z-index: 1000;\n    transform: translateX(-120%);\n    transition: transform var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1));\n    overflow: visible;\n    visibility: hidden;\n  }\n\n  .plugin-drawer.ready {\n    visibility: visible;\n  }\n\n  .plugin-drawer.open {\n    transform: translateX(0);\n  }\n\n  /* Drawer uses flex column so inner scrolls and utility footer pins to bottom */\n  .plugin-drawer {\n    display: flex;\n    flex-direction: column;\n  }\n\n  /* Hide the drawer and hamburger when there are no items */\n  .plugin-drawer.drawer-empty,\n  .drawer-hamburger.drawer-empty {\n    display: none;\n  }\n\n  /* Inner wrapper handles scroll — grows to fill available space above the utility footer */\n  .drawer-inner {\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* ---- Drawer Header ---- */\n  .drawer-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 16px;\n    border-bottom: 2px solid var(--color-dark-border);\n    background: var(--color-dark-background);\n    position: sticky;\n    top: 0;\n    z-index: 1;\n  }\n\n  .drawer-title {\n    font-size: 18px;\n    font-weight: bold;\n    color: white;\n    width: 100%;\n    text-align: center;\n  }\n\n  /* ---- Drawer Search Trigger ---- */\n  .drawer-search {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 12px;\n    background: var(--color-dark-background);\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    border-radius: var(--kt-radius-sm, 4px);\n    margin: 10px 12px;\n    cursor: pointer;\n    transition: border-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),\n      background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .drawer-search:hover {\n    border-color: rgba(255, 255, 255, 0.3);\n    background: rgba(255, 255, 255, 0.06);\n  }\n\n  .drawer-search-icon {\n    width: 16px;\n    height: 16px;\n    opacity: 0.5;\n    flex-shrink: 0;\n    filter: var(--filter-icon-blue);\n  }\n\n  .drawer-search-label {\n    font-size: 13px;\n    color: rgba(255, 255, 255, 0.35);\n    flex: 1;\n  }\n\n  .drawer-search-shortcut {\n    padding: 2px 6px;\n    border-radius: var(--kt-radius-sm, 4px);\n    font-size: var(--kt-font-xs, 11px);\n    font-family: 'Roboto Mono', monospace;\n    color: var(--kt-text-tertiary, rgba(255, 255, 255, 0.45));\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n\n  /* ---- Top Actions Row (search + app launcher) ---- */\n  .drawer-top-actions {\n    display: flex;\n    align-items: center;\n  }\n\n  .drawer-top-actions .drawer-search {\n    flex: 1;\n    min-width: 0;\n    margin-right: 0;\n  }\n\n  /* ---- App Launcher Button ---- */\n  .drawer-app-launcher {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 40px;\n    height: 40px;\n    margin: 10px 12px 10px 8px;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    border-radius: var(--kt-radius-sm, 4px);\n    cursor: pointer;\n    transition: border-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),\n      background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .drawer-app-launcher:hover {\n    border-color: rgba(255, 255, 255, 0.3);\n    background: rgba(255, 255, 255, 0.06);\n  }\n\n  .drawer-app-launcher-icon {\n    width: 20px;\n    height: 20px;\n    opacity: 0.7;\n    filter: var(--filter-icon-blue);\n    transition: opacity var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .drawer-app-launcher:hover .drawer-app-launcher-icon {\n    opacity: 1;\n  }\n\n  /* ---- Drawer Content ---- */\n  .drawer-content {\n    padding-bottom: 20px;\n  }\n\n  /* ---- Collapsible Groups ---- */\n  .drawer-group-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 16px;\n    cursor: pointer;\n    user-select: none;\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: white;\n    background: var(--color-dark-border);\n    border-bottom: 1px solid var(--color-dark-border);\n    transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .drawer-group-header:hover {\n    background: rgba(255, 255, 255, 0.05);\n  }\n\n  .drawer-group-label {}\n\n  .drawer-group-chevron {\n    transition: transform var(--kt-duration-normal, 200ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.4);\n  }\n\n  .drawer-group.collapsed .drawer-group-chevron {\n    transform: rotate(-90deg);\n  }\n\n  .drawer-group-items {\n    overflow: hidden;\n    transition: max-height var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n    max-height: 2000px;\n  }\n\n  .drawer-group.collapsed .drawer-group-items {\n    max-height: 0;\n  }\n\n  /* ---- Drawer Items ---- */\n  .drawer-item {\n    display: flex;\n    align-items: center;\n    padding: 10px 16px;\n    cursor: pointer;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n    transition:\n      background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),\n      transform var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .drawer-item:not(.disabled):hover {\n    background: rgba(255, 255, 255, 0.08);\n  }\n\n  .drawer-item:not(.disabled):active {\n    background: rgba(255, 255, 255, 0.12);\n  }\n\n  .drawer-item:not(.disabled):active .drawer-item-icon {\n    filter: hue-rotate(275deg) brightness(1.2);\n  }\n\n  .drawer-item:active .drawer-item-label {\n    color: var(--color-dark-text-accent);\n  }\n\n  .drawer-item-icon {\n    width: 28px;\n    height: 28px;\n    margin-right: 12px;\n    flex-shrink: 0;\n    filter: var(--filter-icon-blue);\n  }\n\n  .drawer-item-label {\n    font-size: 14px;\n    color: white;\n    flex: 1;\n    min-width: 0;\n  }\n\n  .drawer-item-shortcut {\n    margin-left: auto;\n    padding: 2px 6px;\n    border-radius: var(--kt-radius-sm, 4px);\n    font-size: var(--kt-font-xs, 11px);\n    font-family: 'Roboto Mono', monospace;\n    color: var(--kt-text-tertiary, rgba(255, 255, 255, 0.45));\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n\n  .drawer-item.active .drawer-item-icon {\n    filter: hue-rotate(275deg) brightness(1.2);\n  }\n\n  .drawer-item.active .drawer-item-label {\n    color: var(--color-dark-text-accent);\n  }\n\n  /*\n   * Stay clickable (and hoverable) even when disabled: a click forwards to the\n   * plugin so it can toast *why* it is unavailable, and the not-allowed cursor\n   * signals it is not a normal action. (pointer-events: none would swallow the\n   * click and the hint with it.)\n   */\n  .drawer-item.disabled {\n    opacity: 0.35;\n    cursor: not-allowed;\n  }\n\n  .drawer-item.disabled .drawer-item-icon {\n    filter: grayscale(1);\n  }\n\n  /* ---- Status Badges ---- */\n  .drawer-item-badge:empty {\n    display: none;\n  }\n\n  .drawer-item-badge--active {\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #4caf50;\n    margin-left: 8px;\n    flex-shrink: 0;\n  }\n\n  .drawer-item-badge--count {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 18px;\n    height: 18px;\n    border-radius: 9px;\n    background: var(--color-primary, #1e88e5);\n    color: white;\n    font-size: 10px;\n    font-weight: 600;\n    padding: 0 5px;\n    margin-left: 8px;\n    flex-shrink: 0;\n  }\n\n  /* Pro-locked items — match bottom menu yellow tint, only while logged out.\n     `&` is the enclosing body.drawer-mode, so this gates on the body-level\n     .user-logged-in class without a (never-matching) nested body descendant.\n     .login-gate-bypassed is the Konami-code bypass, which clears the tint too. */\n  &:not(.user-logged-in):not(.login-gate-bypassed) .drawer-item.bmenu-item-pro .drawer-item-icon {\n    filter: hue-rotate(227deg) brightness(1.2);\n  }\n\n  &:not(.user-logged-in):not(.login-gate-bypassed) .drawer-item.bmenu-item-pro:hover .drawer-item-icon {\n    filter: hue-rotate(227deg) brightness(1.8);\n  }\n\n  /* ---- User Account (pinned above utility footer) ---- */\n  .drawer-user-account:empty {\n    display: none;\n  }\n\n  .drawer-user-account {\n    flex-shrink: 0;\n    border-top: 2px solid var(--color-dark-border);\n    background: var(--color-dark-background);\n    padding: 16px;\n  }\n\n  .drawer-user-account__row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 6px 4px;\n    border-radius: 6px;\n    cursor: pointer;\n    text-decoration: none;\n    color: white;\n    transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .drawer-user-account__row:hover {\n    background: rgba(255, 255, 255, 0.08);\n  }\n\n  .drawer-user-account__avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    object-fit: cover;\n    flex-shrink: 0;\n  }\n\n  .drawer-user-account__avatar--default {\n    filter: grayscale(1);\n  }\n\n  .drawer-user-account__initials {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #aeaeae;\n    font-weight: 600;\n    font-size: 0.8rem;\n    color: var(--color-dark-background);\n  }\n\n  .drawer-user-account__name {\n    font-size: 13px;\n    font-weight: 500;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  /* ---- Status Footer Container ---- */\n  .drawer-status-footer-container:empty {\n    display: none;\n  }\n\n  .drawer-status-footer-container {\n    flex-shrink: 0;\n    padding: 12px 16px;\n    border-top: 1px solid var(--color-dark-border);\n    background: var(--color-dark-background);\n  }\n\n  /* ---- Status Footer ---- */\n  .drawer-status-footer {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.45);\n  }\n\n  .drawer-status-connectivity {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n  }\n\n  .drawer-status-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #4caf50;\n    flex-shrink: 0;\n  }\n\n  .drawer-status-dot--offline {\n    background: #f44336;\n  }\n\n  .drawer-status-connectivity-label {\n    color: #4caf50;\n  }\n\n  .drawer-status-connectivity-label--offline {\n    color: #f44336;\n  }\n\n  .drawer-status-version {\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.35);\n  }\n\n  .drawer-phone-link {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 40px;\n    height: 40px;\n    margin-left: auto;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    border-radius: var(--kt-radius-sm, 4px);\n    cursor: pointer;\n    transition: border-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),\n      background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .drawer-phone-link:hover {\n    border-color: rgba(255, 255, 255, 0.3);\n    background: rgba(255, 255, 255, 0.06);\n  }\n\n  .drawer-phone-link-icon {\n    width: 20px;\n    height: 20px;\n    color: var(--kt-accent-light, #e01a0e);\n    opacity: 0.9;\n    transition: opacity var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .drawer-phone-link:hover .drawer-phone-link-icon {\n    opacity: 1;\n  }\n\n  /* Signed out: yellow + disabled (sign in to enable). */\n  .drawer-phone-link--disabled {\n    cursor: default;\n  }\n\n  .drawer-phone-link--disabled:hover {\n    border-color: rgba(255, 255, 255, 0.15);\n    background: transparent;\n  }\n\n  .drawer-phone-link--disabled .drawer-phone-link-icon {\n    color: #f6c343;\n    opacity: 0.6;\n  }\n\n  .drawer-phone-link--disabled:hover .drawer-phone-link-icon {\n    opacity: 0.6;\n  }\n\n  /* ---- Utility Footer (fixed to bottom-right of viewport) ---- */\n  .drawer-utility-footer:empty {\n    display: none;\n  }\n\n  .drawer-utility-footer {\n    position: fixed;\n    bottom: 12px;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 10000;\n    background: rgba(30, 30, 30, 0.75);\n    backdrop-filter: blur(16px);\n    -webkit-backdrop-filter: blur(16px);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 14px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    overflow: hidden;\n    /* Collapsed: small centered pill */\n    max-width: 48px;\n    padding: 6px;\n    gap: 0;\n    cursor: pointer;\n    transition: max-width var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1)),\n      padding var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1)),\n      gap var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1)),\n      border-radius var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1));\n  }\n\n  /* .expanded pins the hover state open (mobile tap-to-expand reuses it, and\n     the onboarding tour pins it while a step spotlights a footer icon) */\n  .drawer-utility-footer:hover,\n  .drawer-utility-footer.expanded {\n    max-width: 90vw;\n    padding: 6px 12px;\n    gap: 2px;\n    cursor: default;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);\n  }\n\n  /* Collapsed indicator — grid icon */\n  .drawer-utility-footer::before {\n    content: '\\2630';\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    font-size: 18px;\n    color: rgba(255, 255, 255, 0.5);\n    flex-shrink: 0;\n    transition: opacity var(--kt-duration-fast, 100ms),\n      width var(--kt-duration-slow, 300ms),\n      margin var(--kt-duration-slow, 300ms);\n  }\n\n  .drawer-utility-footer:hover::before,\n  .drawer-utility-footer.expanded::before {\n    width: 0;\n    opacity: 0;\n    overflow: hidden;\n    margin: 0;\n  }\n\n  /* Sections flow horizontally with dividers */\n  .drawer-utility-section {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 4px;\n    /* Hidden when collapsed */\n    max-width: 0;\n    opacity: 0;\n    overflow: hidden;\n    transition: max-width var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1)),\n      opacity var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1));\n  }\n\n  .drawer-utility-footer:hover .drawer-utility-section,\n  .drawer-utility-footer.expanded .drawer-utility-section {\n    max-width: 600px;\n    opacity: 1;\n  }\n\n  /* Vertical divider between sections */\n  .drawer-utility-section+.drawer-utility-section::before {\n    content: '';\n    display: block;\n    width: 1px;\n    height: 20px;\n    background: rgba(255, 255, 255, 0.15);\n    flex-shrink: 0;\n    margin-right: 4px;\n  }\n\n  .drawer-utility-section-label {\n    display: none;\n    /* Labels hidden in dock mode — icons are self-explanatory with tooltips */\n  }\n\n  .drawer-utility-icons {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 2px;\n  }\n\n  .drawer-utility-icon {\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    border-radius: 8px;\n    transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),\n      transform var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .drawer-utility-icon img {\n    width: 20px;\n    height: 20px;\n    filter: var(--filter-icon-blue);\n    opacity: 0.7;\n    transition: opacity var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .drawer-utility-icon:hover {\n    background: rgba(255, 255, 255, 0.12);\n    transform: scale(1.15);\n  }\n\n  .drawer-utility-icon:hover img {\n    opacity: 1;\n  }\n\n  .drawer-utility-icon:active img {\n    filter: hue-rotate(275deg) brightness(1.2);\n    opacity: 1;\n  }\n\n  .drawer-utility-icon.bmenu-item-selected img {\n    filter: hue-rotate(275deg) brightness(1.2);\n    opacity: 1;\n  }\n\n  .drawer-utility-icon.bmenu-item-disabled {\n    pointer-events: none;\n  }\n\n  .drawer-utility-icon.bmenu-item-disabled img {\n    opacity: 0.2;\n    filter: grayscale(1);\n  }\n\n  /* ---- Rail Toggle Button ---- */\n  .drawer-rail-toggle {\n    display: none;\n  }\n\n}\n\n/* ===================================================================\n   Desktop-specific styles\n   =================================================================== */\nbody.drawer-mode:not(.is-mobile-mode) {\n\n  .plugin-drawer.desktop-mode {\n    width: 420px;\n    top: var(--top-menu-height);\n    height: calc(100% - var(--top-menu-height));\n  }\n\n  /* Desktop: hide hamburger — rail is always visible */\n  .drawer-hamburger {\n    display: none !important;\n  }\n\n  .drawer-item {\n    padding: 8px 16px;\n  }\n\n  .drawer-item-icon {\n    width: 24px;\n    height: 24px;\n  }\n\n  .drawer-item-label {\n    font-size: 13px;\n  }\n\n  /* Hide nav items that moved to the drawer utility footer or are redundant */\n  #sound-btn,\n  #layers-menu-btn,\n  #GithubLinkPlugin-root,\n  #search-btn,\n  .user-account__menu-item {\n    display: none !important;\n  }\n\n  /* Always-open search bar on desktop */\n  #search-holder {\n    display: flex !important;\n    width: 420px !important;\n    transition: none !important;\n  }\n\n  #search-holder.search-slide-up {\n    width: 420px !important;\n    border-left: 5px solid var(--color-dark-border);\n\n  }\n\n  #search-holder.search-slide-up input[type='search'] {\n    width: 100% !important;\n    padding-left: 10px !important;\n    padding-right: 10px !important;\n  }\n\n  /* ---- Rail Toggle Button (desktop only) ---- */\n  .drawer-rail-toggle {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n    padding: 10px 16px;\n    cursor: pointer;\n    color: rgba(255, 255, 255, 0.4);\n    border-top: 1px solid var(--color-dark-border);\n    font-size: 12px;\n    transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .drawer-rail-toggle:hover {\n    background: rgba(255, 255, 255, 0.08);\n    color: rgba(255, 255, 255, 0.7);\n  }\n\n  .drawer-rail-toggle-icon {\n    width: 28px;\n    height: 28px;\n    flex-shrink: 0;\n    filter: var(--filter-icon-blue);\n  }\n\n  .drawer-rail-toggle-label {\n    flex: 1;\n    color: rgba(255, 255, 255, 0.45);\n  }\n\n  .drawer-rail-toggle-shortcut {\n    padding: 2px 6px;\n    border-radius: var(--kt-radius-sm, 4px);\n    font-size: var(--kt-font-xs, 11px);\n    font-family: 'Roboto Mono', monospace;\n    color: var(--kt-text-tertiary, rgba(255, 255, 255, 0.45));\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n\n  /* ---- Rail Mode (desktop only) ---- */\n  .plugin-drawer.rail-mode {\n    transform: translateX(0);\n    width: 60px;\n    overflow: hidden;\n    transition: width var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1)),\n      box-shadow var(--kt-duration-slow, 300ms) var(--kt-easing-enter, cubic-bezier(0, 0, 0.2, 1));\n  }\n\n  /* The whole top-actions row collapses in rail mode so plugin-injected\n     buttons (e.g. the favorites filter/export) collapse with it instead of\n     lingering as orphaned boxes above the drawer items */\n  .plugin-drawer.rail-mode .drawer-top-actions {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-top-actions {\n    max-height: 60px;\n  }\n\n  .plugin-drawer.rail-mode .drawer-search {\n    overflow: hidden;\n    max-height: 0;\n    padding: 0;\n    margin: 0;\n    border: none;\n    opacity: 0;\n    transition: max-height var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),\n      padding var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),\n      margin var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),\n      opacity var(--kt-duration-normal, 200ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  /* App launcher collapses with the search in rail mode */\n  .plugin-drawer.rail-mode .drawer-app-launcher {\n    max-width: 0;\n    margin: 0;\n    border: none;\n    opacity: 0;\n    overflow: hidden;\n    transition: max-width var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),\n      margin var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),\n      opacity var(--kt-duration-normal, 200ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-app-launcher {\n    max-width: 40px;\n    margin: 10px 12px 10px 8px;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    opacity: 1;\n  }\n\n  .plugin-drawer.rail-mode .drawer-group-header {\n    padding: 10px 12px;\n    justify-content: center;\n    background: transparent;\n    pointer-events: none;\n  }\n\n  .plugin-drawer.rail-mode .drawer-group-label {\n    display: none;\n  }\n\n  .plugin-drawer.rail-mode .drawer-group-chevron {\n    display: none;\n  }\n\n  .plugin-drawer.rail-mode .drawer-group-header::after {\n    content: '';\n    display: block;\n    width: 24px;\n    height: 1px;\n    background: rgba(255, 255, 255, 0.12);\n    transition: opacity var(--kt-duration-normal, 200ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .plugin-drawer.rail-mode .drawer-item {\n    position: relative;\n    padding: 8px 12px;\n    justify-content: center;\n    transition: padding var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .plugin-drawer.rail-mode .drawer-item-label {\n    display: none;\n  }\n\n  .plugin-drawer.rail-mode .drawer-item-icon {\n    margin-right: 0;\n    transition: margin var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .plugin-drawer.rail-mode .drawer-item-shortcut {\n    display: none;\n  }\n\n  .plugin-drawer.rail-mode .drawer-item-badge--count {\n    position: absolute;\n    top: 2px;\n    right: 2px;\n    margin-left: 0;\n    font-size: 8px;\n    min-width: 14px;\n    height: 14px;\n    border-radius: 7px;\n    padding: 0 3px;\n  }\n\n  .plugin-drawer.rail-mode .drawer-item-badge--active {\n    position: absolute;\n    top: 4px;\n    right: 4px;\n    margin-left: 0;\n    width: 6px;\n    height: 6px;\n  }\n\n  .plugin-drawer.rail-mode .drawer-user-account,\n  .plugin-drawer.rail-mode .drawer-status-footer-container {\n    opacity: 0;\n    max-height: 0;\n    padding: 0;\n    border: none;\n    overflow: hidden;\n    transition: max-height var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),\n      opacity var(--kt-duration-normal, 200ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1)),\n      padding var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .plugin-drawer.rail-mode .drawer-rail-toggle {\n    justify-content: center;\n    padding: 10px 0;\n  }\n\n  .plugin-drawer.rail-mode .drawer-rail-toggle-icon {\n    width: 28px;\n    height: 28px;\n  }\n\n  .plugin-drawer.rail-mode .drawer-rail-toggle-label {\n    display: none;\n  }\n\n  .plugin-drawer.rail-mode .drawer-rail-toggle-shortcut {\n    display: none;\n  }\n\n  /* Collapsed groups should still show icons in rail mode */\n  .plugin-drawer.rail-mode .drawer-group.collapsed .drawer-group-items {\n    max-height: 2000px;\n  }\n\n  /* Restore normal collapse behavior when rail is hovered (expanded) */\n  .plugin-drawer.rail-mode.rail-hover .drawer-group.collapsed .drawer-group-items {\n    max-height: 0;\n  }\n\n  /* Rail mode hover expansion — triggered by JS class on .drawer-inner hover */\n  .plugin-drawer.rail-mode.rail-hover {\n    width: 420px;\n    box-shadow: 4px 0 16px rgba(0, 0, 0, 0.3);\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-inner {\n    min-width: 420px;\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-search {\n    max-height: 60px;\n    padding: 10px 12px;\n    margin: 10px 12px;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    opacity: 1;\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-group-header {\n    padding-left: 16px;\n    padding-right: 16px;\n    justify-content: space-between;\n    background: var(--color-dark-border);\n    pointer-events: auto;\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-group-label {\n    display: inline;\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-group-chevron {\n    display: inline;\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-group-header::after {\n    opacity: 0;\n    height: 0;\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-item {\n    padding-left: 16px;\n    padding-right: 16px;\n    justify-content: flex-start;\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-item-label {\n    display: inline;\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-item-icon {\n    margin-right: 12px;\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-item-shortcut {\n    display: inline;\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-item-badge--count,\n  .plugin-drawer.rail-mode.rail-hover .drawer-item-badge--active {\n    position: static;\n    margin-left: 8px;\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-item-badge--count {\n    font-size: 10px;\n    min-width: 18px;\n    height: 18px;\n    border-radius: 9px;\n    padding: 0 5px;\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-item-badge--active {\n    width: 8px;\n    height: 8px;\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-user-account {\n    opacity: 1;\n    max-height: 100px;\n    padding: 16px;\n    border-top: 2px solid var(--color-dark-border);\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-status-footer-container {\n    opacity: 1;\n    max-height: 80px;\n    padding: 12px 16px;\n    border-top: 1px solid var(--color-dark-border);\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-rail-toggle {\n    padding: 10px 16px;\n    justify-content: flex-start;\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-rail-toggle-label {\n    display: inline;\n  }\n\n  .plugin-drawer.rail-mode.rail-hover .drawer-rail-toggle-shortcut {\n    display: inline;\n  }\n\n  /* Side menus respect the rail offset */\n  .side-menu-parent {\n    left: var(--drawer-offset, 0px);\n  }\n\n}\n\n/* ===================================================================\n   Mobile-specific styles (device-based, not viewport-based)\n   =================================================================== */\nbody.is-mobile-mode {\n\n  /* Mobile hamburger is in the nav bar (top-left) */\n  .drawer-hamburger {\n    position: relative;\n    width: var(--nav-bar-height);\n    height: var(--nav-bar-height);\n    background: transparent;\n    flex-shrink: 0;\n  }\n\n  /* Compact orange logo for mobile */\n  .nav-logo {\n    padding-left: 0.25rem;\n  }\n\n  .nav-logo img {\n    height: 28px;\n  }\n\n  .plugin-drawer.mobile-mode {\n    width: 80%;\n    top: 0;\n    height: 100%;\n  }\n\n  .drawer-overlay {\n    background: rgba(0, 0, 0, 0.7);\n  }\n\n  .drawer-item {\n    padding: 12px 16px;\n  }\n\n  .drawer-item-icon {\n    width: 28px;\n    height: 28px;\n  }\n\n  .drawer-item-label {\n    font-size: 14px;\n  }\n\n  /* ---- Hide desktop bottom menu on mobile ---- */\n  footer#nav-footer {\n    display: none !important;\n  }\n\n  /* ---- Hide top menu icon <li> items (they're in the drawer now) ---- */\n  #nav-top-right>li {\n    display: none !important;\n  }\n\n  /* ---- Always-open search on mobile ---- */\n  #search-holder {\n    display: flex !important;\n    width: 140px !important;\n    margin-left: auto;\n    transition: none !important;\n  }\n\n  #search-holder.search-slide-up {\n    width: 140px !important;\n  }\n\n  #search-holder.search-slide-up input[type='search'] {\n    width: 100% !important;\n    padding-left: 10px !important;\n    padding-right: 10px !important;\n  }\n\n  .drawer-search {\n    display: none !important;\n  }\n\n  /* Hide keyboard shortcut hints on mobile */\n  .drawer-item-shortcut,\n  .drawer-rail-toggle-shortcut {\n    display: none !important;\n  }\n\n  /* Hide the search toggle button (search is always visible) */\n  #search-btn {\n    display: none !important;\n  }\n\n  /* ---- Nav wrapper mobile layout ---- */\n  #nav-wrapper {\n    justify-content: space-between !important;\n    align-items: center !important;\n  }\n\n  #nav-top-center {\n    flex: 1;\n    min-width: 0;\n  }\n\n  #nav-top-right {\n    flex-shrink: 0;\n  }\n\n  /* ---- Force side menus to full-screen on mobile ---- */\n  .side-menu-parent {\n    position: fixed !important;\n    top: var(--top-menu-height) !important;\n    left: 0 !important;\n    right: 0 !important;\n    bottom: 0 !important;\n    width: 100vw !important;\n    max-width: 100vw !important;\n    min-width: 0 !important;\n  }\n\n  /* Prevent wide content from expanding the side menu beyond viewport */\n  .side-menu {\n    overflow-x: hidden !important;\n    max-width: 100vw !important;\n  }\n\n  /* Make title text flexible so close button stays on-screen */\n  .side-menu-title-text {\n    width: auto !important;\n    flex: 1 1 0 !important;\n    min-width: 50% !important;\n    max-width: none !important;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: clamp(0.75rem, 3.5vw, 1rem);\n  }\n\n  /* Ensure close button section doesn't shrink below its content */\n  .side-menu-title-right {\n    flex-shrink: 0 !important;\n  }\n\n  /* Add right padding to close button so it's not cramped against the edge */\n  .side-menu-title-bar {\n    padding-right: 0.5rem;\n    max-width: 100%;\n    overflow: hidden;\n  }\n\n  /* Allow horizontal scrolling inside the content area for wide tables */\n  .side-menu .row {\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    max-width: calc(100vw - 2rem);\n  }\n\n  /* Force tables inside side menus to be scrollable */\n  .side-menu table {\n    display: block;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    max-width: calc(100vw - 2rem);\n  }\n\n  .side-menu thead,\n  .side-menu tbody {\n    display: block;\n    width: max-content;\n    min-width: 100%;\n  }\n\n  /* ---- Utility footer: replace :hover with .expanded class on mobile ---- */\n  .drawer-utility-footer {\n    /* Disable hover-based expansion on touch devices */\n    max-width: 48px;\n    padding: 6px;\n    gap: 0;\n  }\n\n  .drawer-utility-footer:hover {\n    max-width: 48px;\n    padding: 6px;\n    gap: 0;\n    cursor: pointer;\n    box-shadow: none;\n  }\n\n  .drawer-utility-footer:hover::before {\n    width: 28px;\n    opacity: 1;\n    overflow: visible;\n  }\n\n  .drawer-utility-footer:hover .drawer-utility-section {\n    max-width: 0;\n    opacity: 0;\n  }\n\n  /* JS-toggled expanded state */\n  .drawer-utility-footer.expanded {\n    max-width: 90vw;\n    padding: 6px 12px;\n    gap: 2px;\n    cursor: default;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);\n  }\n\n  .drawer-utility-footer.expanded::before {\n    width: 0;\n    opacity: 0;\n    overflow: hidden;\n    margin: 0;\n  }\n\n  .drawer-utility-footer.expanded .drawer-utility-section {\n    max-width: 600px;\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
